import React, { Suspense, lazy, useState } from 'react'
import { Modal, useBreakpoints } from '@web/walter-ui-kit'

import { useIntl } from 'react-intl'
import { SettingsTabs } from './Menu/const'
import Preloader from './Preloader'
import { useSettingsModal } from './useSettingsModal'
import { lang } from './lang'
import { SumSubState } from './Content'

const Content = lazy(() => import('./Content'))

function SettingsModal() {
    const { isMobile } = useBreakpoints()
    const { tab, setTab, close, isOpen } = useSettingsModal()
    const [sumSub, setSumSub] = useState<SumSubState>({ isOpen: false, token: '' })

    const intl = useIntl()
    const modalTitle = isMobile && lang[tab] ? intl.formatMessage(lang[tab]) : intl.formatMessage(lang.settings)

    const onClose = () => {
        close()
        setSumSub({ isOpen: false, token: '' })
    }

    return (
        <Modal
            size={sumSub?.isOpen ? 'xl' : 'm'}
            height={sumSub?.isOpen ? 860 : 580}
            width={sumSub?.isOpen ? 752 : undefined}
            onClose={onClose}
            isOpen={isOpen}
            title={modalTitle}
            dataPointer="settings_modal"
            withContentPaddings={false}
            maxHeightMobile
            withBackButton={isMobile && !sumSub.isOpen && tab !== SettingsTabs.menu}
            onBackButtonClick={() => setTab(SettingsTabs.menu)}
        >
            <Suspense fallback={<Preloader />}>
                <Content tab={tab} onChangeTab={setTab} isMobile={isMobile} sumSub={sumSub} setSumSub={setSumSub} />
            </Suspense>
        </Modal>
    )
}

export default SettingsModal
